'use client';

import ReportPage from '@/app/report-page';

export default function Page({ params }: { params: { id: string } }) {
  // You can fetch report data based on params.id here
  return <ReportPage />;
}
